import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"

const CardsOtherServicesSkeleton = () => {
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const cardClasses = classnames(
    styles.cardSkeleton,
    styles.whiteBackgroundSkeleton
  )
  return (
    <Fragment>
      <div className={titleClasses}></div>
      <div className="u-flex">
        <div className={cardClasses}></div>
        <div className={cardClasses}></div>
        <div className={cardClasses}></div>
        <div className={cardClasses}></div>
      </div>
    </Fragment>
  )
}
export default CardsOtherServicesSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/CardsOtherServicesSkeleton/index.js